import React from "react";
import { Row, Col } from "react-flexbox-grid";
import { Query } from "react-apollo";
import Typography from "@material-ui/core/Typography";
import gql from "graphql-tag";
import List from "./list";
import PaperContainer from "../../../paper-container";
import DownloadButton from "./button-download-stats-file";
import UploadButton from "./button-upload-stats-file";

export const QUERY = gql`
  query($layer: ID!) {
    statsTaskByLayer(layer: $layer) {
      id
    }
  }
`;

const CartoStatsDashboard = ({ match }) => {
  const { layerId } = match.params;
  return (
    <PaperContainer
      title={
        <Row>
          <Col xs={10}>
            <Typography variant="h6" gutterBottom>
              Datos estadísticos
            </Typography>
          </Col>
          <Col xs={2}>
            <DownloadButton layer={layerId} />
            <UploadButton layer={layerId} />
          </Col>
        </Row>
      }
    >
      <Query query={QUERY} variables={{ layer: layerId }}>
        {({ data, loading, error }) => {
          if (error || loading) {
            return null;
          }
          const { statsTaskByLayer } = data;
          return (
            <List items={statsTaskByLayer} query={QUERY} layer={layerId} />
          );
        }}
      </Query>
    </PaperContainer>
  );
};

export default CartoStatsDashboard;



// WEBPACK FOOTER //
// ./src/components/admin/carto/stats/index.js